import PropTypes from 'prop-types';
import { Mask } from 'components/common';
import { unmask } from 'sdk/internalAccount';

const LoanNumberMask = ({ deletedOnly, fspId, icon, item }) => (
  <Mask
    api={() => unmask({ id: item.id, fspId: fspId ?? item.fspId }, deletedOnly)}
    icon={icon}
    value={item.accountNbrMask ?? undefined}
  />
);

LoanNumberMask.propTypes = {
  deletedOnly: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  fspId: PropTypes.number,
  icon: PropTypes.bool,
  item: PropTypes.shape({
    accountNbrMask: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    fspId: PropTypes.number,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

LoanNumberMask.defaultProps = {
  deletedOnly: undefined,
  fspId: undefined,
  icon: true,
};

export default LoanNumberMask;
